import ky from 'ky';
let promise = null;
import store from './store'
async function refreshSessione() {
    if (promise) await promise;
    else {
        promise = (async () => {
            const res = await ky.post('./api/Session/Refresh').json();
            if (res.status) {
                store.commit("setSession",res);
                promise = null;
            } else throw Error();
        })();
        await promise;
    }
}

export default ky.create({
    hooks: {
        beforeRequest: [
            async () => {
                var cookies = document.cookie.split(";");
                if (!cookies.some(x => x.indexOf("menualvolo_session_token=") !== -1)) {
                    await refreshSessione();
                }
            },
        ],
    },
}, );